const messages = {
  heading: "Start the chat with a friendly message"
};

export default messages;
